var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg9816",
    viewBox: "0 0 352 373.33334",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9820"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9832"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,280 H 264 V 0 H 0 Z",
    id: "path9830"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9844"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 104.662,236.872 C 87.566,227.279 76,208.976 76,188 v 0 -6.2 C 70.3,180.9 66,175.9 66,170 v 0 -14 c 0,-6.1 4.5,-11.1 10.3,-11.9 v 0 C 78.4,124.3 90.8,107.6 108,99.4 v 0 V 81 h -4 C 76.341,81 52.353,65.449 40.292,42.604 v 0 C 62.304,16.546 95.219,0 132,0 v 0 c 36.782,0 69.697,16.546 91.709,42.604 v 0 C 211.647,65.449 187.659,81 160,81 v 0 h -4 v 18.4 c 17.2,8.2 29.6,24.9 31.7,44.7 v 0 c 5.8,0.8 10.3,5.8 10.3,11.9 v 0 14 c 0,5.9 -4.3,10.8 -10,11.8 v 0 6.2 c 0,20.976 -11.567,39.279 -28.663,48.872 v 0 C 150.556,238.919 141.405,240 132,240 v 0 c -9.404,0 -18.556,-1.082 -27.338,-3.128",
    id: "path9842"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9856"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76,165 H 188 V 86 H 76 Z",
    id: "path9854"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9872"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12,120 C 12,53.726 65.726,0 132,0 v 0 c 66.275,0 120,53.726 120,120 v 0 c 0,66.274 -53.725,120 -120,120 v 0 C 65.726,240 12,186.274 12,120",
    id: "path9870"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9884"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,280 H 264 V 0 H 0 Z",
    id: "path9882"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9900"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 120,150 h 24 v -8 h -24 z",
    id: "path9898"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9936"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32,8.9 V 0 h 200 v 8.9 c 0,37.8 -29,68.8 -66,71.8 v 0 -1 C 166,67.8 151,58.2 132.5,58.2 v 0 C 114,58.2 99,67.8 99,79.7 v 0 1.1 C 61.6,78.2 32,47 32,8.9",
    id: "path9934"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 92.9,105.1 h 79.2 V 51.3 H 92.9 Z",
    id: "path9942"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9960"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,280 H 264 V 0 H 0 Z",
    id: "path9958"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g9824",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,373.33333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9828",
    clipPath: "url(#clipPath9832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9834",
    transform: "translate(132,240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 66.274,0 120,-53.726 120,-120 0,-66.274 -53.726,-120 -120,-120 -66.274,0 -120,53.726 -120,120 0,66.274 53.726,120 120,120",
    style: {
      fill: "#65c9ff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9836"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g9838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9840",
    clipPath: "url(#clipPath9844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9846",
    transform: "translate(156,99.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -18.4 h 4 c 39.8,0 72,-32.2 72,-72 v -9 h -200 v 9 c 0,39.8 32.2,72 72,72 h 4 V 0 C -65.2,8.2 -77.6,24.9 -79.7,44.7 -85.5,45.5 -90,50.5 -90,56.6 v 14 c 0,5.9 4.3,10.9 10,11.8 v 6.2 c 0,30.9 25.1,56 56,56 30.9,0 56,-25.1 56,-56 v -6.2 c 5.7,-1 10,-5.9 10,-11.8 v -14 C 42,50.5 37.5,45.5 31.7,44.7 29.6,24.9 17.2,8.2 0,0",
    style: {
      fill: "#edb98a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9848"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9850"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g9852"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9864"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9856)",
    opacity: 0.100006,
    id: "g9862"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(188,165)",
    id: "g9860"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -23 c 0,-30.9 -25.1,-56 -56,-56 -30.9,0 -56,25.1 -56,56 V 0 -15 c 0,-30.9 25.1,-56 56,-56 30.9,0 56,25.1 56,56 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9858"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "g9866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9868",
    clipPath: "url(#clipPath9872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9874",
    transform: "translate(166,80.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 37,-3 66,-34 66,-71.8 v -8.9 h -200 v 8.9 c 0,38.1 29.6,69.3 67,71.9 V -1 c 0,-11.9 15,-21.5 33.5,-21.5 C -15,-22.5 0,-12.9 0,-1 Z",
    style: {
      fill: "#ff5c5c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9876"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g9878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9880",
    clipPath: "url(#clipPath9884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9886",
    transform: "translate(124,110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 8,-18.7 17,0",
    style: {
      fill: "#4a312c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9888"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9890",
    transform: "translate(123,128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 18 c 1.7,0 3,-1.3 3,-3 0,-1.7 -1.3,-3 -3,-3 H 0 c -1.7,0 -3,1.3 -3,3 0,1.7 1.3,3 3,3",
    style: {
      fill: "#4a312c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9892"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9894"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g9896"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9908"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9900)",
    opacity: 0.160004,
    id: "g9906"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,150)",
    id: "g9904"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-4.4 5.4,-8 12,-8 6.6,0 12,3.6 12,8",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9902"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g9910",
    transform: "translate(103.2,169.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.8,-1 -1.2,-2.3 -1.2,-3.7 0,-3.3 2.7,-6 6,-6 3.3,0 6,2.7 6,6 0,0.3 0,0.6 -0.1,0.9 0,0.2 0,0.5 -0.1,0.7 0,0.1 -0.1,0.2 -0.1,0.4 -0.3,1 -0.9,1.8 -1.6,2.5 -2.1,2.2 -5.5,3.6 -9,3.6 -4.8,0 -9,-2.6 -10.8,-6.4 -0.5,-1.1 0.4,-1.9 1.3,-1.1 2.4,2 5.8,3.2 9.6,3.2 C -0.1,0 0,0 0,0",
    style: {
      fill: "#4a312c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9912"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9914",
    transform: "translate(161.2,169.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.8,-1 -1.2,-2.3 -1.2,-3.7 0,-3.3 2.7,-6 6,-6 3.3,0 6,2.7 6,6 0,0.3 0,0.6 -0.1,0.9 0,0.2 0,0.5 -0.1,0.7 0,0.1 -0.1,0.2 -0.1,0.4 -0.3,1 -0.9,1.8 -1.6,2.5 -2.1,2.2 -5.5,3.6 -9,3.6 -4.8,0 -9,-2.6 -10.8,-6.4 -0.5,-1.1 0.4,-1.9 1.3,-1.1 2.4,2 5.8,3.2 9.6,3.2 C -0.1,0 0,0 0,0",
    style: {
      fill: "#4a312c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9916"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9918",
    transform: "translate(173,190.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -6.6,2.5 -15.2,-0.7 -21.8,-2 -3.7,-0.7 -7.5,-1.3 -11.1,-2.3 -1.5,-0.4 -2.9,-1.2 -4.3,-1.3 -0.7,-0.1 -1.1,-0.9 -0.6,-1.4 1.5,-1.7 5.6,-2.7 7.6,-3 6.3,-0.8 12.3,1.5 18.4,2.7 5.4,1 11.6,1.9 16.7,-0.9 C 5,-8.3 6.1,-8.9 6.6,-9.4 7,-9.8 7.6,-9.7 7.9,-9.2 9.2,-6.4 1.5,-0.6 0,0 m -39.1,-5.2 z",
    style: {
      fill: "#4a312c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9920"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9922",
    transform: "translate(91.9,190.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.6,2.5 15.2,-0.7 21.8,-2 3.7,-0.7 7.5,-1.3 11.1,-2.3 1.5,-0.4 2.9,-1.2 4.3,-1.3 0.7,-0.1 1.1,-0.9 0.6,-1.4 -1.5,-1.7 -5.6,-2.7 -7.6,-3 -6.3,-0.8 -12.3,1.5 -18.4,2.7 -5.4,1 -11.6,1.9 -16.7,-0.9 -0.1,-0.1 -1.2,-0.7 -1.7,-1.2 -0.4,-0.4 -1,-0.3 -1.3,0.2 -1.3,2.8 6.4,8.7 7.9,9.2 m 39.1,-5.2 z",
    style: {
      fill: "#4a312c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9924"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9926",
    transform: "translate(132,138.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -6.8,3.6 -16.4,4.1 -21.6,2.2 -5.8,-2.2 -10.9,-8.5 -19.7,-5.7 -0.4,0.1 -0.7,-0.2 -0.6,-0.6 1.4,-4.5 9,-7.6 11.6,-7.7 11.3,-0.4 20.4,8.3 30.3,8.9 9.9,-0.7 19,-9.4 30.4,-8.9 2.6,0.1 10.2,3.2 11.6,7.7 0.1,0.4 -0.2,0.7 -0.6,0.6 C 32.5,-6.3 27.4,0 21.7,2.2 16.4,4.2 6.8,3.6 0,0",
    style: {
      fill: "#4a312c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9928"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g9930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9932",
    clipPath: "url(#clipPath9936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9938"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g9940"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9952"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9944)",
    opacity: 0.160004,
    id: "g9950"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.5,105.1)",
    id: "g9948"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 21.87,0 39.6,-12.044 39.6,-26.9 0,-14.856 -17.73,-26.9 -39.6,-26.9 -21.87,0 -39.6,12.044 -39.6,26.9 C -39.6,-12.044 -21.87,0 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9946"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "g9954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9956",
    clipPath: "url(#clipPath9960)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9962",
    transform: "translate(132,268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 c 36.5,0 66,-29.5 66,-66 v -5 H -66 v 5 c 0,36.5 29.5,66 66,66",
    style: {
      fill: "#ff5c5c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9964"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9966",
    transform: "translate(66,218.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 7.9,40.1 12,-16.2 23.9,25.2 21.7,-20 21.7,20 L 110.4,25.6 121.7,41 131,0 Z",
    style: {
      fill: "#ffbb40",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9968"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9970",
    transform: "translate(66,218.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 15.9,11.6 37.9,17.5 65.8,17.5 27.9,0 49.8,-5.8 65.7,-17.4 2.1,-1.5 3.3,-3.9 3.3,-6.5 v -30.5 c 0,-2.2 -1.8,-4 -4,-4 -0.8,0 -1.5,0.2 -2.1,0.6 -16.6,10.5 -37.3,15.8 -62.1,15.8 -24.9,0 -46.2,-5.3 -63.7,-16 -1.9,-1.1 -4.3,-0.5 -5.5,1.3 -0.4,0.6 -0.6,1.3 -0.6,2.1 V -6.4 C -3.3,-3.9 -2.1,-1.5 0,0",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path9972"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKing);
export default __webpack_public_path__ + "static/media/King.c043bb9491593517bdbab43e17f4d4db.svg";
export { ForwardRef as ReactComponent };